import React, { useEffect, useState } from "react";
import {
  convertAmmountToWords as convertAmountToWords,
  placeBid_AuctionFloor,
} from "services";
import CrossIcon from "../../../../../icons/CrossIcon";
import { Button } from "../../../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { DateTime } from "luxon";
import { BidConfirmationModalV2 } from "./BidConfirmationModalV2";

interface PlaceBidButtonSectionProps {
  eventData: any;
  amount: any;
  id: any;
  status: any;
  reservePrice: any;
  latestBid: any;
  biddingType: any;
  connectionStatus: any;
  isTimeEnded: any;
  isHighestBidder?: any;
}

export default function PlaceBidButtonSection({
  eventData,
  amount,
  id,
  status,
  reservePrice,
  latestBid,
  biddingType,
  connectionStatus,
  isTimeEnded,
  isHighestBidder = false,
}: PlaceBidButtonSectionProps) {
  const [showBidConfirmation, setShowBidConfirmation] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [bidPreparedAt, setBidPreparedAt] = useState<Date | null>(null);
  const form = useBetaForm({
    bidding_value: "",
  });
  const form_constraints_rp = {
    bidding_value: {
      presence: {
        allowEmpty: false,
        message:
          "can't be blank and can't contain any special character or alphanumeric values",
      },
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo:
          typeof amount === "string" ? parseInt(amount) : amount,
        lessThan:
          typeof amount === "string"
            ? parseInt(amount) + parseInt(amount)
            : amount + amount,
        notLessThan:
          "^Attention: Your bid must be with in the minimum and maximum threshold value. Please revise your bid and resubmit",
      },
    },
  };

  const form_constraints_no_rp = {
    bidding_value: {
      presence: {
        allowEmpty: false,
        message:
          "can't be blank and can't contain any special character or alphanumeric values",
      },
      numericality: {
        onlyInteger: true,
        greaterThan: typeof amount === "string" ? parseInt(amount) : amount,
        lessThan:
          typeof amount === "string"
            ? parseInt(amount) + parseInt(amount)
            : amount + amount,
        notLessThan:
          "^Attention: Your bid must be with in the minimum and maximum threshold value. Please revise your bid and resubmit",
      },
    },
  };

  useEffect(() => {
    if (!showBidConfirmation) {
      if (biddingType === "rp" && !latestBid) {
        form.setValidationRules(form_constraints_rp);
      } else {
        form.setValidationRules(form_constraints_no_rp);
      }

      if (!latestBid) {
        // if (biddingType === "rp") {
        //   form.setField("bidding_value", parseInt(reservePrice));
        // } else {
        //   form.setField(
        //     "bidding_value",
        //     parseInt(reservePrice) +
        //       parseInt(eventData?.bidding_increment_amount)
        //   );
        // }
        form.setField("bidding_value", parseInt(reservePrice));
      } else {
        form.setField("bidding_value", parseInt(amount));
        //+ parseInt(eventData?.bidding_increment_amount)
      }
    }
  }, [amount, biddingType, latestBid, showBidConfirmation]);

  const handlePlaceBidAfterConfirmation = async (biddingValue: number) => {
    setLoading(true);
    try {
      if (form.validate()) {
        const current_date_object = DateTime.now().setZone("Asia/Kolkata");
        const payload = {
          event_type: "user_has_placed_bid",
          event_uuid: id,
          bidding_amount:
            typeof biddingValue === "string"
              ? parseInt(biddingValue)
              : biddingValue,
          frontend_timestamp: current_date_object.toMillis(),
        };
        await placeBid_AuctionFloor(payload);
      }
    } catch (error: any) {
      console.log("check here error:-> ", error);
    }
    setLoading(false);
  };
  const handlePluseBid = () => {
    try {
      // if (form.validate()) {
      form.setField(
        "bidding_value",
        parseInt(form.getField("bidding_value")) +
          eventData?.bidding_increment_amount,
      );
      form.validate();
      // }
    } catch (error) {
      console.log("chec khere error", error);
    }
  };
  const handleMinusBid = () => {
    try {
      // if (form.validate()) {
      const minBidValue =
        typeof amount === "string" ? parseInt(amount) : amount;
      if (minBidValue < form.getField("bidding_value")) {
        form.setField(
          "bidding_value",
          form.getField("bidding_value") - eventData?.bidding_increment_amount,
        );
      }
      // }
      form.validate();
    } catch (error) {
      console.log("chec khere error", error);
    }
  };
  // const calculateNextBid = () => {
  //   let nextPossibleBid = 0;
  //   if (!latestBid) {
  //     if (biddingType === "rp") {
  //       nextPossibleBid = parseInt(reservePrice);
  //     } else {
  //       nextPossibleBid =
  //         parseInt(reservePrice) +
  //         parseInt(eventData?.bidding_increment_amount);
  //     }
  //   } else {
  //     nextPossibleBid =
  //       parseInt(amount) + parseInt(eventData?.bidding_increment_amount);
  //   }
  //   return nextPossibleBid;
  // };
  // console.log("amount--", amount);

  return (
    <div className="flex flex-col gap-[14px] relative mt-2">
      <div className="flex items-center">
        <Button
          className="rounded-none px-3"
          onClick={handleMinusBid}
          disabled={
            status !== "live" ||
            ["Offline", "Connecting"].includes(connectionStatus) ||
            isTimeEnded === 1 ||
            // // calculateNextBid() >= parseInt(form.getField("bidding_value"))
            parseInt(amount) === parseInt(form.getField("bidding_value"))
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8008 12.9078H6V12H17.8008V12.9078Z"
              fill="white"
            />
          </svg>
        </Button>
        <div className="w-full text-center text-sm  border-y-[1px] h-[38px] flex items-center justify-center tracking-wider">
          <div>{`₹ ${form.getField("bidding_value")}`}</div>
        </div>
        <Button
          className="rounded-none px-3"
          onClick={async () => {
            await handlePluseBid();
          }}
          disabled={
            status !== "live" ||
            ["Offline", "Connecting"].includes(connectionStatus) ||
            isTimeEnded === 1
            // ||
            // form.errors.get("bidding_value")?.[0]
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12.75 11.25V6H11.25V11.25H6V12.75H11.25V18H12.75V12.75H18V11.25H12.75Z"
              fill="white"
            />
          </svg>
        </Button>
      </div>
      {form.errors.get("bidding_value") && (
        <p className="-mt-2 text-xs font-sans text-red-800 text-center">
          {form.errors.get("bidding_value")[0]}
        </p>
      )}
      <Button
        className="w-full"
        onClick={() => {
          if (form.validate()) {
            setBidPreparedAt(new Date());
            setShowBidConfirmation(true);
          }
        }}
        disabled={
          status !== "live" ||
          ["Offline", "Connecting"].includes(connectionStatus) ||
          isTimeEnded === 1
        }
      >
        Place bid
      </Button>
      {showBidConfirmation && (
        <BidConfirmationModalV2
          open={showBidConfirmation}
          onOpenChange={(open) => setShowBidConfirmation(open)}
          biddingValue={form.getField("bidding_value")}
          amountInWords={convertAmountToWords(form.getField("bidding_value"))}
          status={status}
          connectionStatus={connectionStatus}
          isTimeEnded={isTimeEnded}
          loading={loading}
          onConfirm={(value) => handlePlaceBidAfterConfirmation(Number(value))}
          isHighestBidder={isHighestBidder}
          bidPreparedAt={bidPreparedAt || undefined}
        />
      )}
    </div>
  );
}
